export const InitStatusAll = { title: 'Выбрать все', checked: false };

// Статусы,которые были до

// { id: 0, key: 'atWork', title: 'В работе', checked: false, code: 6 },
// { id: 1, key: 'stopped', title: 'Остановлена', checked: false, code: 7 },
// { id: 2, key: 'piezometric', title: 'Пьезометрическая', checked: false, code: 10 },
// { id: 3, key: 'inConservation', title: 'В консервации', checked: false, code: 11 },
// { id: 4, key: 'inLiquidation', title: 'В ликвидации', checked: false, code: 12 },
// { id: 5, key: 'pendingLiquidation', title: 'В ожидании ликвидации', checked: false, code: 13 },
// { id: 6, key: 'inIntermittentUse', title: 'В периодической эксплуатации', checked: false, code: 14 },
// { id: 7, key: 'inactiveSinceThisYear', title: 'В бездействии с текущего года', checked: false, code: 16 },
// { id: 8, key: 'inactiveSincePreviousYears', title: 'В бездействии с прошлых лет', checked: false, code: 17 },
// { id: 9, key: 'inDevelopmentSinceTheCurrentYear.',title: 'В освоении с текущего года', checked: false, code: 19 },
// { id: 10, key: 'inDevelopmentFromPreviousYears', title: 'В освоении с прошлых лет', checked: false, code: 21 },
// { id: 11, key: 'observant', title: 'Наблюдательная', checked: false, code: 376 },
// { id: 12, key: 'withoutStatus', title: 'Без статуса', checked: false, code: 0 },

export const InitStatuses = [
    { id: 0, key: 'atWork', title: 'В работе', checked: false, code: '001' },
    { id: 1, key: 'stopped', title: 'Остановлена', checked: false, code: '002' },
    { id: 2, key: 'piezometric', title: 'Пьезометрическая', checked: false, code: ['006', '031'] }, //031
    { id: 3, key: 'inConservation', title: 'В консервации', checked: false, code: '007' },
    { id: 4, key: 'inLiquidation', title: 'В ликвидации', checked: false, code: '008' },
    { id: 5, key: 'pendingLiquidation', title: 'В ожидании ликвидации', checked: false, code: '009' },
    { id: 6, key: 'inIntermittentUse', title: 'В периодической эксплуатации', checked: false, code: '010' },
    { id: 7, key: 'inactiveSinceThisYear', title: 'В бездействии с текущего года', checked: false, code: '022' },
    { id: 8, key: 'inactiveSincePreviousYears', title: 'В бездействии с прошлых лет', checked: false, code: '023' },
    {
        id: 9,
        key: 'inDevelopmentSinceTheCurrentYear.',
        title: 'В освоении с текущего года',
        checked: false,
        code: '025',
    },
    { id: 10, key: 'inDevelopmentFromPreviousYears', title: 'В освоении с прошлых лет', checked: false, code: '027' },
    { id: 11, key: 'observant', title: 'Наблюдательная', checked: false, code: ['005', '032'] }, //032
    { id: 12, key: 'withoutStatus', title: 'Без статуса', checked: false, code: '0' },
];

export const itemNotDeepWell = [
    { id: 6, key: 'hydrogeological', checked: false, title: 'Гидрогеологическая', code: 6 },
    { id: 22, key: 'artezian', checked: false, title: 'Артезианская', code: 22 },
    { id: 8, key: 'waterReservour', checked: false, title: 'Водозаборная', code: 8 },
    { id: 7, key: 'shourfs', checked: false, title: 'Шурфы', code: 7 },
];
